import styled from 'styled-components';

export const ArenaDescriptionTextDefaultBox = styled.div`
    font-size: 1.4rem;
    ${({theme}) => theme.font.presets.regular};
    color: ${props => props.theme.colors.textMiddleDark};
    font-weight: 300;
    line-height: normal;
    padding-top: 1rem;
`;